import { cancelLoginClaimPendingAtLoad } from "./loginClaimPending";
import { installExclusiveLoginFetchGate } from "./exclusiveLoginFetchGate";
import { handleLoginSuperseded } from "./loginSupersededHandler";

let booted = false;

/**
 * 로그인 배타성 부팅. `_app` 모듈 스코프(브라우저, `Amplify.configure` 직후, 첫 렌더 전)에서 부른다.
 *
 * 1. fetch 관문을 설치한다. 첫 백엔드 요청보다 먼저여야 한다. 관문은 밀려남 신호를 감지할 뿐 아니라 main-api·FlightHub
 *    진입 요청을 막기도 한다 — 점유 대기 중에는 점유 `PUT` 외 요청을 네트워크 없이 거절하고, 밀려남 처리 중에는 합성
 *    밀려남 `401` 을 돌려준다. 감지한 밀려남은 단일 처리기로 모으고, 다른 탭에도 전파한다(가장 최근 탭 사건이
 *    로그아웃이면 전파하지 않는다 — `handleLoginSuperseded`).
 * 2. 로드 시점에 남아 있는 점유 대기를 취소한다. 앱이 로그인 여부를 판정하기 전에, 네트워크 없이 세션 키를 지운다.
 *    이전 로드가 버린 점유와 다른 탭에서 확인창이 떠 있는 점유를 가리지 못해 둘 다 취소한다 — 후자의 탭은 확인이
 *    실패로 끝난다(`cancelLoginClaimPendingAtLoad`, 스펙 「확인창 중 새 탭 열기」).
 *
 * 브라우저 전용이며, 다시 불러도 무동작이다.
 */
export function bootExclusiveLogin(): void {
  if (booted || typeof window === "undefined") return;
  booted = true;

  installExclusiveLoginFetchGate({
    onSuperseded: () => void handleLoginSuperseded({ broadcast: true }),
  });
  cancelLoginClaimPendingAtLoad();
}
